"use strict";import{StatusLight as t}from"./src/StatusLight.js";import{defineElement as e}from"@spectrum-web-components/base/src/define-element.js";e("sp-status-light",t);
//# sourceMappingURL=sp-status-light.js.map
